<template>
  <div id="app" class="uk-height-1-1" :class="{'red-bg': isRedBg}">
    <router-view></router-view>
    <autoLogout />
  </div>
</template>

<script>
import autoLogout from './components/autoLogout'

export default {
  name: 'app',
  data: () => ({
    redRouter: ['login', 'passwordChange', 'passwordRestore', 'notFound', 'error']
  }),
  components: {autoLogout},
  computed: {
    isRedBg() {
      return this.redRouter.includes(this.$route.name)
    }
  }
}
</script>

<style>
.red-bg {
  background-color: #dd1319;
}
</style>
